import React, { Component } from 'react';
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import {AndroidAppUrl,IosAppUrl,PwaAppUrl} from './../../constants';
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class Refer extends Component{
    static contextType = AuthContext;
    state = {
        data:{}
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
            fetch(ApiBaseUrl + "/consumer/profile",
                {
                    method: 'GET',
                    headers:
                        {
                            "Authorization": "Bearer "+this.context.token
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if(!result.success)
                            this.props.openSnackbar(result.message)
                        else
                            this.setState({
                                data: result.data
                            });
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
    }
    render(){
        return(
            <React.Fragment>
                {this.state.data.name &&
                <div className="choose-deals-outer p-l-0 p-r-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 mx-auto px--xs-0">
                                <div className="referconsumer-box bg-grey d-flex justify-content-center flex-column">
                                    <h6 className="text-white text-center d-block mb-4">Choose any option below</h6>
                                    <div className="referconsumer-innerbox">

                                        <a href="https://www.addtoany.com/share#url=https%3A%2F%2Fhost4vip.com%2Fhome%2F&amp;title=Host4VIP" rel="noopener noreferrer" target="_blank" className="ref--btn"><p className="help-control"><i className="fa fa-envelope-o font-20" aria-hidden="true"></i></p><span>Social Media</span></a>
                                        <a href={"mailto:?subject=Welcome%20to%20Host4VIP%20Platform.&body=" + this.state.data.name + "%20has%20referred%20Host4VIP%20to%20you.%20Visit%20the%20URLs%20mentioned%20below%20to%20download%20the%20application%20from%20App%20store%20or%20Play%20store.%20You%20can%20also%20visit%20Host4VIP%20website.%20Proceed%20to%20create%20your%20account%20and%20unlock%20amazing%20deals.%0D%0A%0D%0AiOS%20App%20-%20" + IosAppUrl + "%0D%0A%0D%0AAndroid%20App%20-%20" + AndroidAppUrl + "%0D%0A%0D%0AWebsite%20Link%20-%20" + PwaAppUrl } className="ref--btn"><p className="help-control"><i className="fa fa-at font-20" aria-hidden="true"></i></p><span>Email</span>
                                        </a>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </React.Fragment>
        )
    }
}

export default withSnackbar(Refer,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});